module.exports = require("froala-editor/css/froala_editor.pkgd.min.css");